import {
  getLocalStorageItem,
  localstorageKeys,
  setLocalStorageItem,
} from 'hooks';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import useAPI from 'services/axios';

import { Endpoints, queryKeys } from '../constants';

// Login API //
const Login = (payload: any) => {
  return useAPI({ method: 'POST', url: Endpoints.LOGIN, data: payload });
};

export const useLoginQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(Login, {
    onSuccess: (response: any) => {
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
      setLocalStorageItem('dependents', response?.data?.dependents);
      setLocalStorageItem('independent', response?.data?.user);
      if (response?.data?.oauth?.preAuthToken) {
        setLocalStorageItem(
          'PREAUTH_TOKEN',
          response?.data?.oauth?.preAuthToken
        );
      } else {
        setLocalStorageItem('AUTH_TOKEN', response?.data?.oauth?.oauthToken);
      }
      setLocalStorageItem(
        'REFRESH_TOKEN',
        response?.data?.oauth?.oauthRefreshToken
      );
    },
  });
};

const SetupNewPin = (payload: any) => {
  const preAuthToken = getLocalStorageItem('PREAUTH_TOKEN');
  return useAPI({
    method: 'POST',
    url: Endpoints.SET_NEW_PIN,
    data: payload,
    headers: {
      Authorization: `Bearer ${preAuthToken}`,
    },
  });
};

export const useSetupNewPinQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(SetupNewPin, {
    onSuccess: (response: any) => {
      // queryClient.setQueryData([QueryKeys.AUTH_ME], response?.data?.user);
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
      // setLocalStorageItem('AUTH_TOKEN', response?.data?.oauth?.oauthToken);
      // setLocalStorageItem(
      //   'REFRESH_TOKEN',
      //   response?.data?.oauth?.oauthRefreshToken
      // );
    },
  });
};
const VerifyPin = (payload: any) => {
  return useAPI({ method: 'POST', url: Endpoints.VERIFY_PIN, data: payload });
};

export const useVerifyPinQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(VerifyPin, {
    onSuccess: (response: any) => {
      // queryClient.setQueryData([QueryKeys.AUTH_ME], response?.data?.user);
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
      // setLocalStorageItem('AUTH_TOKEN', response?.data?.oauth?.oauthToken);
      // setLocalStorageItem(
      //   'REFRESH_TOKEN',
      //   response?.data?.oauth?.oauthRefreshToken
      // );
    },
  });
};
const setIdelTime = (payload: any) => {
  return useAPI({
    method: 'PATCH',
    url: `oauth/idle?status=${payload?.status}`,
  });
};

export const useSetIdelTimeQuery = () => {
  return useMutation(setIdelTime);
};

// Auth Me Api //
const getAuthMe = () => {
  return useAPI({ method: 'GET', url: Endpoints.AUTH_ME });
};

export const useAuthMe = () => {
  // const queryClient = useQueryClient();
  const authSession = getLocalStorageItem('AUTH_TOKEN');
  return useQuery([queryKeys.AUTH_ME], () => getAuthMe(), {
    enabled: Boolean(authSession),
    onSuccess: (response: any) => {
      setLocalStorageItem('roles', response?.data);
      // queryClient.setQueryData([queryKeys.AUTH_ME], response?.data?.user);
    },
  });
};

// forget password Api //
const forgetPassword = (data: any) => {
  return useAPI({ method: 'POST', url: Endpoints.FORGOT_PASSWORD, data });
};

export const useForgetPasswordQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(forgetPassword, {
    onSuccess: () => {
      // queryClient.setQueryData([QueryKeys.AUTH_ME], response?.data?.user);
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
    },
  });
};

// forgot password sent code api//

const forgetPasswordSentCode = (data: any) => {
  return useAPI({ method: 'POST', url: Endpoints.FORGOT_PASSWORD_CODE, data });
};

export const useForgetPasswordSentCodeQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(forgetPasswordSentCode, {
    onSuccess: (response: any) => {
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
    },
  });
};
const ResendCode = (data: any) => {
  return useAPI({ method: 'POST', url: Endpoints.RESEND_CODE, data });
};

export const useResendCodeQuery = () => {
  return useMutation(ResendCode);
};

// Set New Password Api //
const createNewPassword = (data: any) => {
  return useAPI({
    method: 'PATCH',
    url: Endpoints.SET_NEW_PASSWORD,
    data,
  });
};

export const useCreateNewPasswordQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(createNewPassword, {
    onSuccess: () => {
      // queryClient.setQueryData([QueryKeys.AUTH_ME], response?.data?.user);
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
    },
  });
};

const LogOutApi = (data: any) => {
  return useAPI({ method: 'DELETE', url: `device` });
};

export const useLogOutApiQuery = () => {
  return useMutation(LogOutApi);
};

const getDashboardStats = (userDetails: any, frequency = 'monthly') => {
  return useAPI({
    method: 'GET',
    url: `stats?accountId=${userDetails?.account?.id}&frequency=${frequency}`,
  });
};

export const useDashboardStats = (
  userDetails: { account: { id: any } },
  frequency: string | undefined
) => {
  return useQuery(
    [queryKeys.DASHBOARD_STATS, frequency],
    () => getDashboardStats(userDetails, frequency),
    {
      cacheTime: 0,
      enabled: Boolean(userDetails?.account?.id),
      onSuccess: (response: any) => {
        // setLocalStorageItem('roles', response?.data);
        // queryClient.setQueryData([queryKeys.AUTH_ME], response?.data?.user);
      },
    }
  );
};

const TwoFACode = (data: any) => {
  const preAuthToken = getLocalStorageItem('PREAUTH_TOKEN');
  return useAPI({
    method: 'POST',
    url: `/oauth/2fa`,
    data,
    headers: {
      Authorization: `Bearer ${preAuthToken}`,
    },
  });
};

export const useTwoFACode = () => {
  const queryClient = useQueryClient();
  return useMutation(TwoFACode, {
    onSuccess: (response: any) => {
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
    },
  });
};

export const RefreshAccessToken = () => {
  const refreshTokenn = getLocalStorageItem('REFRESH_TOKEN');
  const method = 'POST';
  const url = `/oauth/refresh-token/`;
  const data = {
    refreshToken: refreshTokenn,
  };
  return useAPI({ method, url, data });
};

export const handleRefreshAuthtokens = (response: {
  data: { oauthToken: any; oauthRefreshToken: any };
}) => {
  const { oauthToken, oauthRefreshToken } = response.data;
  setLocalStorageItem(localstorageKeys.AUTH_TOKEN, oauthToken);
  setLocalStorageItem(localstorageKeys.REFRESH_TOKEN, oauthRefreshToken);
};
